import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Packages from "@/components/Packages";
import Accessories from "@/components/Accessories";
import RedLightSystems from "@/components/RedLightSystems";
import EFAMPhilosophy from "@/components/EFAMPhilosophy";
import FounderStory from "@/components/FounderStory";
import ForgedPoemSection from "@/components/ForgedPoemSection";
import TrustSafety from "@/components/TrustSafety";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SafetyPage from "@/components/SafetyPage";
import TermsPage from "@/components/TermsPage";
import PrivacyPage from "@/components/PrivacyPage";
import RefundPage from "@/components/RefundPage";
import CheckoutSuccess from "@/components/CheckoutSuccess";
import CheckoutCancel from "@/components/CheckoutCancel";
import ShopAll from "@/components/ShopAll";
import NotFoundPage from "@/components/NotFoundPage";
import RouteMetadata from "@/components/RouteMetadata";
import StructuredData from "@/components/StructuredData";
import { Toaster } from "@/components/ui/sonner";

const LandingPage = () => {
  return (
    <>
      <StructuredData />
      <Header />
      <Hero />
      <Packages />
      <Accessories />
      <RedLightSystems />
      <EFAMPhilosophy />
      <FounderStory />
      <ForgedPoemSection />
      <TrustSafety />
      <FAQ />
      <Contact />
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <RouteMetadata />
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/safety" element={<SafetyPage />} />
          <Route path="/safety-information" element={<SafetyPage />} />
          <Route path="/terms-of-service" element={<TermsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/refund-policy" element={<RefundPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/cancel" element={<CheckoutCancel />} />
          <Route path="/full-range" element={<ShopAll />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
